/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeCompletedCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakeCompletedCtrl', ["dialog", "reporttime", "$scope", "Stocktakes", "title", function(dialog, reporttime, $scope, Stocktakes, title) {
  reporttime.defaultType = 'week';

  title.set('Stocktake Archive');

  $scope.stocktakes = Stocktakes.getArchive(reporttime.start(), reporttime.end());
}]);
